enum PGLimit {
  PG_LIMIT = 10,
}

export default PGLimit;
